import { ChangeEvent } from 'react';
import { layout } from '../../NewHire/v2/styles';
import { RATING_DIRECTOR_REVIEW } from '../utils/questionsCatalog';

interface DirectorReviewStepProps {
  topStrengths: string[];
  opportunitiesForGrowth: string[];
  onTopStrengthsChange: (index: number, value: string) => void;
  onOpportunitiesChange: (index: number, value: string) => void;
}

const DirectorReviewStep = ({
  topStrengths,
  opportunitiesForGrowth,
  onTopStrengthsChange,
  onOpportunitiesChange,
}: DirectorReviewStepProps) => {
  const strengthsCount = RATING_DIRECTOR_REVIEW.topStrengthsCount;
  const opportunitiesCount = RATING_DIRECTOR_REVIEW.opportunitiesForGrowthCount;

  return (
    <div>
      <h2 style={{ ...layout.title, marginBottom: 4 }}>Director Review</h2>
      <p style={layout.subtitle as any}>Summarize the employee&apos;s strengths and growth opportunities.</p>

      <div style={{ marginTop: 20 }}>
        <label style={layout.label as any}>Top Strengths</label>
        {Array.from({ length: strengthsCount }).map((_, i) => (
          <input
            key={`strength-${i}`}
            type="text"
            value={topStrengths[i] || ''}
            placeholder={`Strength ${i + 1}`}
            onChange={(e: ChangeEvent<HTMLInputElement>) => onTopStrengthsChange(i, e.target.value)}
            style={{ ...(layout.input as any), marginBottom: 10 }}
          />
        ))}
      </div>

      <div style={{ marginTop: 16 }}>
        <label style={layout.label as any}>Opportunities for Growth</label>
        {Array.from({ length: opportunitiesCount }).map((_, i) => (
          <input
            key={`opp-${i}`}
            type="text"
            value={opportunitiesForGrowth[i] || ''}
            placeholder={`Opportunity ${i + 1}`}
            onChange={(e: ChangeEvent<HTMLInputElement>) => onOpportunitiesChange(i, e.target.value)}
            style={{ ...(layout.input as any), marginBottom: 10 }}
          />
        ))}
      </div>
    </div>
  );
};

export default DirectorReviewStep;
